import {useContext} from 'react';
import {GoogleOAuthContext} from '../context';

export function useGoogleOAuth() {
    const context = useContext(GoogleOAuthContext);
    if (!context) {
        throw new Error(
            'Google OAuth components must be used within GoogleOAuthProvider',
        );
    }
    return context;
}
